import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/languageContext';
import { applyAppPageTitle, applyLandingSeo, isLandingRoute } from '../lib/pageSeo';

export const usePageSeo = (): void => {
    const { pathname } = useLocation();
    const { t, i18n } = useTranslation();
    const { currentLanguage } = useLanguage();

    useEffect(() => {
        if (!i18n.isInitialized) {
            return;
        }

        if (isLandingRoute(pathname)) {
            applyLandingSeo(t('app.seoTitle'), t('app.seoDescription'));
            return;
        }

        applyAppPageTitle(t('app.pageTitle'));
    }, [pathname, currentLanguage, i18n.isInitialized, t]);
};
